const WOW = require("wow.js");

jQuery(document).ready(() => {
	var wow = new WOW({
		animateClass: 'animated',
		offset: 0,
    live: false,
    mobile: false,
	});

  wow.init();
});



// WEBPACK FOOTER //
// ./scripts/autoload/_wowjs.js